import React from "react";
import { ImageIcon } from "lucide-react";
import { SquareCatalogProduct } from "../types/SquareCatalog";
type ProductImageProps = {
  product: SquareCatalogProduct;
  alt?: string;
};
export function ProductImage({
  product,
  alt
}: ProductImageProps) {
  if (product.imageUrl) {
    return <img src={product.imageUrl} alt={alt ?? product.name} className="aspect-square w-full bg-[#220d20] object-cover" data-id="element-243" data-mp="2gn6dr84emqfh" />;
  }
  return <div className="flex aspect-square w-full items-center justify-center border border-white/10 bg-[#220d20] text-center text-sm text-white/60" data-id="element-244" data-mp="2bol82t6dvejn">
      <div data-id="element-245" data-mp="22n3wno3x811a">
        <ImageIcon className="mx-auto mb-2 text-[#35dceb]" size={24} aria-hidden="true" data-id="element-246" data-mp="22mvgnnci4flv" />
        Product image coming from Square
      </div>
    </div>;
}